/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_SelectedInputs */



/**
* | output |
* | --- |
* | "Selected" |
*
* @param {Common_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const common_selected = /** @type {((inputs?: Common_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionne")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgewählt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Selezionato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Избранные")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已选")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択済み")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecionado")
	return /** @type {LocalizedString} */ ("Selected")
});